module.exports = __webpack_public_path__ + "img/pop-icon-1.d8d807e8.png";